import React from 'react';
import PropTypes from 'prop-types';

import AddToCallListLink from 'components/call_lists/add_to_call_list_link';

/**
 * Dropdown submenu row to add the contact to one of the listed call lists
 */
export default class AddToCallListDropdown extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callLists: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })),
    contact: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      type: PropTypes.string
    }),
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
  };

  static defaultProps = {
    callLists: [],
    contact: {},
  };

  render() {
    const { callLists, contact } = this.props;
    if (!contact || !callLists.length === 0) return null;

    return (
      <React.Fragment>
        <li className="dropdown-submenu" role="presentation">
          <a className="clickable dropdown-item">
            Add to Call List            
            <i className="fas fa-caret-right text-muted"></i>
          </a>
          <ul className="dropdown-menu">
            {this.renderLinks()}
          </ul>
        </li>
      </React.Fragment>
    );
  }

  renderLinks = () => {
    const { callLists } = this.props;
    return callLists.map(this.renderLink);
  }

  renderLink = (list) => {
    const { availableDatabases, contact, currentUser, databaseMembers } = this.props;

    return (
      <li key={list.id}>
        <AddToCallListLink
          availableDatabases={availableDatabases}
          callList={list}
          currentUser={currentUser}
          databaseMembers={databaseMembers}
          selectedContacts={[contact]}
        />
      </li>
    );
  }
}
